import React from 'react';
import Icon from '../../../components/AppIcon';

const MoodSelector = ({ selectedMood, onMoodSelect }) => {
  const moodOptions = [
    {
      id: 'high',
      label: 'High Desire',
      icon: 'Flame',
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10',
      description: 'Feeling very interested and energetic'
    },
    {
      id: 'moderate',
      label: 'Moderate',
      icon: 'Heart',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10',
      description: 'Open to intimacy if timing is right'
    },
    {
      id: 'low',
      label: 'Low Interest',
      icon: 'Moon',
      color: 'var(--color-secondary)',
      bgColor: 'bg-secondary/10',
      description: 'Not feeling particularly interested'
    },
    {
      id: 'unavailable',
      label: 'Not Available',
      icon: 'X',
      color: 'var(--color-muted-foreground)',
      bgColor: 'bg-muted',
      description: 'Not available for intimacy right now'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-heading font-semibold text-foreground">
        Current Mood
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {moodOptions?.map((mood) => (
          <button
            key={mood?.id}
            onClick={() => onMoodSelect(mood?.id)}
            className={`
              flex items-start space-x-3 p-4 rounded-md border-2
              transition-therapeutic text-left
              ${selectedMood === mood?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/30'
              }
            `}
          >
            <div className={`
              flex items-center justify-center w-12 h-12 rounded-md flex-shrink-0
              ${mood?.bgColor}
            `}>
              <Icon name={mood?.icon} size={24} color={mood?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <span className="text-base font-medium text-foreground">
                  {mood?.label}
                </span>
                {selectedMood === mood?.id && (
                  <Icon name="Check" size={16} color="var(--color-primary)" />
                )}
              </div>
              <p className="text-sm text-muted-foreground line-clamp-2">
                {mood?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MoodSelector;